import { MiddotSeparated } from "@indietabletop/appkit";
import type { ReactNode } from "react";
import type { VehicleProfile } from "../../engine/Ruleset.ts";
import { caps, list } from "../fmt.ts";
import { type FormOptionProps, FormOption } from "../forms/FormTextField.tsx";
import { useGangContext } from "../GangPage/useGang.ts";

export function VehicleFormOption(
  props: Pick<FormOptionProps, "name" | "type"> & {
    profile: VehicleProfile;
    counter?: ReactNode;
    priceMultiplier?: number;
  },
) {
  const { profile, counter, priceMultiplier = 1, ...optionProps } = props;
  const { gang } = useGangContext();

  const special = [
    ...profile.rules.map((ref) => gang.ruleset.vehicleSpecialRules.get(ref.id)),
    ...profile.mods.map((ref) => gang.ruleset.mods.get(ref.id)),
  ];

  return (
    <FormOption
      {...optionProps}
      value={profile.id}
      label={profile.name}
      info={caps(profile.cost * priceMultiplier)}
      description={
        <>
          <MiddotSeparated>
            <span>Engine: {profile.engine}</span>
            <span>Seats: {profile.seats}</span>
            <span>Toughness: {profile.toughness}</span>
          </MiddotSeparated>

          {special.length > 0 && <div>Special: {list(special)}</div>}

          {counter}
        </>
      }
    />
  );
}
